import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { ChartContainer, ChartConfig } from '@/components/ui/chart';
import { format } from 'date-fns';
import { ar } from 'date-fns/locale';

const chartConfig: ChartConfig = {
  delivery_fees:  { label: 'رسوم التوصيل', color: 'hsl(217, 91%, 60%)' },
  platform_fees:  { label: 'رسوم المنصة',  color: 'hsl(142, 72%, 42%)' },
  cod_collected:  { label: 'COD محصّل',    color: 'hsl(38, 92%, 50%)'  },
};

interface Props {
  data: { date: string; delivery_fees: number; platform_fees?: number; cod_collected: number }[];
  showPlatformFees?: boolean;
}

function formatDate(d: string) {
  try { return format(new Date(d), 'd MMM', { locale: ar }); } catch { return d; }
}

function formatAmount(v: number) {
  return v >= 1000 ? `${(v / 1000).toFixed(1)}k` : String(v);
}

export function RevenueTrendChart({ data, showPlatformFees = false }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  return (
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <LineChart data={data} margin={{ top: 4, right: 12, left: -16, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border/40" />
        <XAxis dataKey="date" tickFormatter={formatDate} tick={{ fontSize: 11 }} />
        <YAxis tickFormatter={formatAmount} tick={{ fontSize: 11 }} />
        <Tooltip
          contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
          formatter={(v: any, name: string) => [Number(v).toLocaleString(), chartConfig[name]?.label ?? name]}
          labelFormatter={formatDate}
        />
        <Legend formatter={(name) => chartConfig[name]?.label ?? name} wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
        <Line type="monotone" dataKey="delivery_fees" stroke="var(--color-delivery_fees)" strokeWidth={2} dot={false} />
        {showPlatformFees && (
          <Line type="monotone" dataKey="platform_fees" stroke="var(--color-platform_fees)" strokeWidth={2} dot={false} />
        )}
        <Line type="monotone" dataKey="cod_collected" stroke="var(--color-cod_collected)" strokeWidth={2} dot={false} strokeDasharray="4 2" />
      </LineChart>
    </ChartContainer>
  );
}
